import styled from 'styled-components';

export const ScrollToTopButton = styled.button`
  position: fixed;
  z-index: 39;
  bottom: 20px;
  right: 20px;
  background-color: #006FCF;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;

  &:hover {
    background-color: #2980b9;
  }
`;